export default __webpack_public_path__ + "static/media/nwantiti.86a29502.mp3";